import React from "react";
// import classnames from "classnames";
import { Card, CardImg, CardText, CardBody, CardTitle, CardFooter, CardLink, Row, Col } from "reactstrap";
import { FaArrowRight } from "react-icons/fa";
import styles from "./Card.module.scss";
import arrowRightIcon from "../../assets/arrow-right.svg";

const CardSection = ({ data = {}, cardImage, showFooter = true }) => {
  return (
    <Card className={`${styles.card} h-100 text-dark`} tag="a" href={data.link}>
      {cardImage ? (
        <div
          top
          width="100%"
          className={styles.cardImage}
          style={{ backgroundImage: `url(${data.image})` }}
          alt="Card image cap"
        />
      ) : null}
      <CardBody style={cardImage ? { height: "calc(50% - 2.5rem)" } : {}}>
        <CardTitle
          style={{
            lineHeight: "150%",
            letterSpacing: "-0.02em",
          }}
          className={styles.cardTitle}
        >
          {data.post_title}
        </CardTitle>
        {data.content && cardImage ? (
          <CardText className={styles.cardText} dangerouslySetInnerHTML={{ __html: data.content }} />
        ) : null}
      </CardBody>
      <CardFooter className={styles.cardFooter}>
        <Row>
          <Col xs="9" md="9">
            {showFooter ? (
              <>
                {data.format ? (
                  <CardLink
                    className={styles.cardSubText}
                    style={{
                      lineHeight: "140%",
                      color: "rgba(34, 34, 33, 0.7)",
                      marginRight: "0.5rem",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {data.format.name}
                  </CardLink>
                ) : null}
                {data.location ? (
                  <CardLink
                    className={styles.cardSubText}
                    style={{
                      lineHeight: "140%",
                      color: "rgba(34, 34, 33, 0.7)",
                      marginLeft: 0,
                      whiteSpace: "nowrap",
                    }}
                  >
                    {data.location}
                  </CardLink>
                ) : null}
              </>
            ) : null}
          </Col>
          <Col xs="2" md="2" className="text-right p-0">
            <img src={arrowRightIcon} alt="arrow right icon" />
          </Col>
        </Row>
      </CardFooter>
    </Card>
  );
};

export default CardSection;
